import { TextValue } from './text-value.interface';

export enum NoteCategory {
    NONE = 0,
    ACCOUNTING = 1,
    ASSAY_DESIGN,
    ORDERS,
    QUALITY_ASSURANCE,
    SALES,
    STRAINS,
}

export const noteCategoryText: { [key in NoteCategory]: string } = {
    [NoteCategory.NONE]: '',
    [NoteCategory.ACCOUNTING]: 'Accounting',
    [NoteCategory.ASSAY_DESIGN]: 'Assay Design',
    [NoteCategory.ORDERS]: 'Orders',
    [NoteCategory.QUALITY_ASSURANCE]: 'Quality Assurance',
    [NoteCategory.SALES]: 'Sales',
    [NoteCategory.STRAINS]: 'Strains',
};

export const noteCategories: TextValue[] = [
    { text: noteCategoryText[NoteCategory.NONE], value: NoteCategory.NONE },
    { text: noteCategoryText[NoteCategory.ACCOUNTING], value: NoteCategory.ACCOUNTING },
    { text: noteCategoryText[NoteCategory.ASSAY_DESIGN], value: NoteCategory.ASSAY_DESIGN },
    { text: noteCategoryText[NoteCategory.ORDERS], value: NoteCategory.ORDERS },
    { text: noteCategoryText[NoteCategory.QUALITY_ASSURANCE], value: NoteCategory.QUALITY_ASSURANCE },
    { text: noteCategoryText[NoteCategory.SALES], value: NoteCategory.SALES },
    { text: noteCategoryText[NoteCategory.STRAINS], value: NoteCategory.STRAINS },
];
